module.exports = __webpack_public_path__ + "img/podcast_google.61bfa79c.png";